import { render, staticRenderFns } from "./NavigationHeaderDefault.vue?vue&type=template&id=1bc8e4e2&scoped=true&"
import script from "./NavigationHeaderDefault.vue?vue&type=script&lang=js&"
export * from "./NavigationHeaderDefault.vue?vue&type=script&lang=js&"
import style0 from "./NavigationHeaderDefault.vue?vue&type=style&index=0&id=1bc8e4e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8e4e2",
  null
  
)

export default component.exports